import { defineMessages } from '@transcend-io/internationalization';

export const networkErrorMessages = defineMessages(
  'privacy-center.components.NetworkError.networkError',
  {
    header: {
      defaultMessage:
        'Oh no! Our server is not responding, try refreshing the page or coming back in a bit.',
    },
    extension: {
      defaultMessage:
        'If you are using a browser extension that blocks content or network requests, such as Ghostery,' +
        ' try disabling the extension and trying again.',
    },
    alt: {
      defaultMessage: 'something went wrong, our server is not responding',
    },
    title: {
      defaultMessage: 'Cannot reach server!',
    },
  },
);
